import Store from '@/store';
import { ToasterService } from '@/services/common/toaster.service';

export const toasterPlugin = {
  install(vue: any, options: any) {
    vue.prototype.$toaster = new ToasterService(Store, options.i18n);
  },
};
